export const bodyData = [
  [
    {
      color: "green",
      value: "Vert",
    },
    {
      value:
        "Du texte un peu long ici lorem ipsum, lorem ipsum, lorem ipsum, lorem ipsum",
    },
    {
      value: 56,
      color: "red",
    },
    {
      value: "",
    },
  ],
  [
    {
      color: "orange",
      value: "Orange",
    },
    {
      value:
        "Du texte un peu long ici lorem ipsum, lorem ipsum, lorem ipsum, lorem ipsum",
    },
    {
      value: 80,
    },
    {
      value: "une valeur jaune ici",
      color: "#aaaa22",
    },
  ],
  [
    {
      value: "Blablabla",
    },
    {
      color: "red",
      value: "Texte plus court rouge",
    },
    {
      value: 56,
    },
    {
      value: "",
    },
  ],
  [
    {
      value: "Blablabla",
    },
    {
      value: "Texte plus court",
    },
    {
      value: 8754,
    },
    {
      value: "",
    },
  ],
];

export const thead = [
  {
    id: "c1",
    label: "Colonne 1",
  },
  {
    id: "c2",
    label: "Colonne 2",
  },
  {
    id: "c3",
    label: "Colonne 3",
  },
  {
    id: "c4",
    label: "Colonne 4",
  },
];
